import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const ParkingZoneListing = React.lazy(() =>
  import('./parkingZone/ParkingZoneListing'),
);

const ParkingSlotListing = React.lazy(() =>
  import('./parkingSlot/ParkingSlotListing'),
);

export const ParkingManagementConfigs = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/parking-management/parking-zone',
    element: <ParkingZoneListing />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/parking-management/parking-slot',
    element: <ParkingSlotListing />,
  },
];
